import { useSelector } from 'react-redux';
import isFollowingGuideId from '../utils/isFollowingGuideId';

export default function useIsFollowingGuideId(guideId, fallbackOverride) {
  return useSelector((state) =>
    isFollowingGuideId(state, guideId, fallbackOverride),
  );
}
